import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import '../styles/PaymentModeForm.css';
import API_BASE_URL from '../config/apiConfig.js';
import Swal from 'sweetalert2';

const PaymentModeForm = ({ isOpen, onClose, paymentMode, isPage }) => {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [companyId, setCompanyId] = useState('');
    const [companies, setCompanies] = useState([]);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const isSuperAdmin = user?.role === 'SUPER_ADMIN';

    useEffect(() => {
        if (paymentMode) {
            setName(paymentMode.paymentModeName || paymentMode.payment_mode_name || '');
            const cid = paymentMode.companyId || paymentMode.company_id;
            setCompanyId(cid ? cid : 'all');
        } else {
            setName('');
            setCompanyId('');
        }
    }, [paymentMode]);

    useEffect(() => {
        if (isSuperAdmin && isOpen) {
            fetchCompanies();
        }
    }, [isSuperAdmin, isOpen]);

    const fetchCompanies = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(`${API_BASE_URL}/company`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setCompanies(data.companies || data);
            }
        } catch (error) {}
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const conf = await Swal.fire({
            title: 'Save Data?',
            text: 'Are you sure you want to save this data?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#00334e',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'No, Keep Editing'
        });
        if (!conf.isConfirmed) return;
        const trimmedName = name.trim();
        if (!trimmedName) {
            toast.error("Name is required");
            return;
        }

        setLoading(true);
        try {
            const token = sessionStorage.getItem('token');
            const url = paymentMode ? `${API_BASE_URL}/payment-mode/${paymentMode._id || paymentMode.id}` : `${API_BASE_URL}/payment-mode`;

            const method = paymentMode ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ paymentModeName: trimmedName, ...(isSuperAdmin && { companyId }) })
            });

            const data = await response.json();

            if (response.ok) {
                toast.success(paymentMode ? "Payment Mode Updated Successfully" : "Payment Mode Added Successfully");
                onClose();
            } else {
                toast.error(data.message || "Failed to save payment mode");
            }
        } catch (error) {
            console.error("Error saving payment mode:", error);
            toast.error("Server error");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className={isPage ? "list-page-container" : "modal-overlay"}>
            <div className={isPage ? "" : "modal"}>
                <div className="modal-header">
                    <h2 className="modal-title">{paymentMode ? 'Update Payment Mode' : 'Add Payment Mode'}</h2>
                    {!isPage && <button className="modal-close" onClick={onClose}>&times;</button>}
                </div>
                <div className="payment-mode-form-body">
                    <form onSubmit={handleSubmit}>
                        <div className="payment-mode-grid">
                            {isSuperAdmin && (
                                <div className="payment-mode-field">
                                    <label>SELECT COMPANY</label>
                                    <select
                                        value={companyId}
                                        onChange={(e) => setCompanyId(e.target.value)}
                                        required
                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '10px' }}
                                    >
                                        <option value="">Select Company</option>
                                        <option value="all">All</option>
                                        {companies.map(comp => (
                                            <option key={comp._id || comp.id} value={comp._id || comp.id}>
                                                {comp.companyName || comp.name || comp.company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="payment-mode-field">
                                <label>NAME</label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter name"
                                    required
                                />
                            </div>
                        </div>

                        <div className="payment-mode-form-actions">
                            <button type="submit" className="btn-submit" disabled={loading}>
                                {loading ? "Saving..." : "Submit"}
                            </button>
                            <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PaymentModeForm;
